module.exports = (__parcel__import__("dPOfn")).then(() => parcelRequire('fyWP3'));